import React from 'react';
import { Linkedin } from 'lucide-react';
import PageHero from '../components/PageHero';
import { Reveal } from '../components/Reveal';
import { team } from '../mockData';

export default function TeamPage() {
  return (
    <main data-testid="team-page">
      <PageHero
        eyebrow="Our Team"
        title="The People Behind"
        accent="the Promise"
        description="Meet the key personnel who lead Alakhe Conglomerate. Profiles below are placeholders and will be updated with our team's details."
      />

      <section className="py-24 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {team.map((member, index) => (
              <Reveal key={member.id} delay={index * 0.12}>
                <div
                  className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group h-full flex flex-col"
                  data-testid={`team-member-card-${member.id}`}
                >
                  <div className="relative h-80 overflow-hidden bg-gray-200">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-charcoal/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  </div>
                  <div className="p-6 flex flex-col flex-grow">
                    <h3 className="text-xl font-bold text-charcoal mb-1" data-testid={`team-member-name-${member.id}`}>
                      {member.name}
                    </h3>
                    <div className="text-brand-red font-semibold text-sm mb-4">{member.role}</div>
                    <p className="text-gray-600 text-sm leading-relaxed flex-grow">{member.bio}</p>
                    <a
                      href={member.linkedin}
                      aria-label={`${member.role} LinkedIn profile`}
                      data-testid={`team-member-linkedin-${member.id}`}
                      className="mt-5 inline-flex items-center space-x-2 text-charcoal hover:text-brand-red text-sm font-semibold transition-colors"
                    >
                      <span className="w-9 h-9 bg-red-50 rounded-lg flex items-center justify-center">
                        <Linkedin className="w-4 h-4 text-brand-red" />
                      </span>
                      <span>LinkedIn</span>
                    </a>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.2} className="max-w-2xl mx-auto text-center mt-16">
            <p className="text-gray-500 text-sm">
              Team photographs, names, titles, and biographies will be updated as personnel information becomes available.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
